import { buildQuery } from '@packages/common/src/providers/network/open-api-query'

const query = (email: string) =>
  buildQuery('/password_recovery', 'post', 201, {
    data: { email },
  })

export default query
